export default "__VITE_ASSET__xaBcBkOU__"